<template>
  <div>
    <v-text-field
      outlined
      :rules="isItRequired"
      :label="generateLabel"
      @change="handleChange"
      :value="defaultValue"
      :disabled="isDisabled"
      :counter="hasLimit ? limit : null"
      :maxlength="hasLimit ? limit : null"
      dense
      :hint="field.hint"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseField from "@/mixins/BaseField";

export default {
  name: "HTML5Numeric",
  mixins: [BaseField],
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Object],
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    limit: 0,
    unsubscribe: null,
  }),
  computed: {
    ...mapState({
      currentFlow: (state) => state.company.currentFlow,
    }),

    isItRequired() {
      const rules = [this.validation.onlyNumbers, ...this.customRules];
      if (this.hasLimit) {
        rules.push(this.validation.maxLength(this.limit));
      }
      if (this.field.element_required || this.field.required) {
        rules.push(this.validation.required);
      }
      return rules.length ? rules : undefined;
    },
    generateLabel() {
      return this.field.element_required || this.field.required
        ? `${this.field.published_name}*`
        : this.field.published_name;
    },
    hasLimit() {
      return (
        this.field.character_limit &&
        this.field.character_limit.length &&
        this.field.character_limit !== "0"
      );
    },
    isDisabled() {
      if (this.field.protected) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.hasLimit) {
      this.limit = parseInt(this.field.character_limit);
    }
    if (this.field.conditional_visibility) {
      this.handleConditionalVisibility();
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    handleConditionalVisibility() {
      if (!this.field.conditional_visibility_values) return;
      const controllerField =
        this.currentFlow.config.payload_config.root_elements.find(
          (field) =>
            field.published_name === this.field.conditional_visibility_input
        );
      this.subscribeToMasterFieldChanges(controllerField);
    },
    subscribeToMasterFieldChanges(controlField) {
      this.unsubscribe = this.$store.subscribe((mutation) => {
        if (mutation.type === "company/setFlowData") {
          const controlFieldKey = controlField.key;
          if (
            !Object.prototype.hasOwnProperty.call(
              mutation.payload,
              controlFieldKey
            )
          )
            return;
          const value = mutation.payload[controlFieldKey];
          if (this.field.conditional_visibility_values.includes(value)) {
            this.$emit("manage-field-visibility", {
              visibility: false,
              field: this.field.key,
            });
            return;
          }
          this.$emit("manage-field-visibility", {
            visibility: true,
            field: this.field.key,
          });
        }
      });
    },
    handleChange(value) {
      this.$emit("text-change", {
        [this.field.key]: parseInt(value),
      });
    },
  },
};
</script>
